module.exports = __webpack_public_path__ + "img/missionaries31_2019_7-7-2021.c7afafc1.jpg";